module.exports = __webpack_public_path__ + "static/media/objetivo.492f01ab.jpg";